import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';

const DMCAPolicyView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='dmca-container'>
                <span dangerouslySetInnerHTML={{ __html: props.HtmlMarkup }} />
            </div>
        </div>
    );
};

export default DMCAPolicyView;
global.DMCAPolicyView = DMCAPolicyView;